import { SelectionSourceData, SelectionRepositoryReference, SelectionWithMultimediaMixin, } from './internal';
import { SelectionRecord } from './base';
import { SelectionWithNoteMixin } from './mixin';
export class SelectionSourceRecord extends SelectionWithMultimediaMixin(SelectionWithNoteMixin(SelectionRecord)) {
    getData() {
        return this.get("DATA" /* Tag.Data */, null, SelectionSourceData);
    }
    getOriginator() {
        return this.get("AUTH" /* Tag.Author */);
    }
    getDescriptiveTitle() {
        return this.get("TITL" /* Tag.Title */);
    }
    getShortTitle() {
        return this.get("ABBR" /* Tag.Abbreviation */);
    }
    getPublicationFacts() {
        return this.get("PUBL" /* Tag.Publication */);
    }
    getText() {
        return this.get("TEXT" /* Tag.Text */);
    }
    getRepository() {
        return this.get("REPO" /* Tag.Repository */, null, SelectionRepositoryReference);
    }
}
//# sourceMappingURL=SelectionSourceRecord.js.map